<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash>
</sub-header>

<p-scrollPanel styleClass="custombar1" [style]="{width: '100%', height: '60vh'}">
  <div class="container-fluid" *ngIf="loaded">
    <div *ngIf="isDeciphering()">
      <div class="row">
        <div class="col-12" [ngClass]="(this.isDechiperProcessError())? 'rounded validations p-2' : 'alert alert-info'">
          {{ status }}
          <ng-container *ngIf="this.errorEnvelopes && this.errorEnvelopes.size > 0">
            <ul class="plyca-error-list">
              <li *ngFor="let errorEntry of this.errorEnvelopes | keyvalue">
                <strong>{{ errorEntry.key.name }} ({{errorEntry.key.taxIdentifier}})</strong>
                <ul>
                  <li *ngFor="let errEnvelope of errorEntry.value">
                    <i class="fa fa-lg fa-exclamation-circle text-danger" aria-hidden="true"></i>
                    {{'TenderEvaluation.envelopes.name' | translate}} {{errEnvelope.envelope.description}}:
                    {{errEnvelope.decipherErrorMessage}}
                  </li>
                </ul>
              </li>
            </ul>
            <div>{{'TenderEvent.dechiper.repeat' | translate}}</div>
          </ng-container>
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="col-12">
          <p-progressBar [value]="avance"></p-progressBar>
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="col-12">
          <envelope-status-table [envelopes]="envelopes" [inProgress]="avance < 100"></envelope-status-table>
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="widget style1 yellow-bg">
          <div class="row vertical-align">
            <div class="col-5">
              <i class="fa fa-hourglass-half fa-3x"></i>Tiempo transcurrido
            </div>
            <div class="col-7 text-right">
              <h2 class="font-bold">{{ time }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isDeciphering()" class="row m-t-sm">
      <div class="col-12  alert alert-info m-b-lg">
        {{ 'TenderEvent.dechiper.message' | translate }}
      </div>
    </div>

    <!-- <div class="row mt-2">
      <div class="btn-group-xs col-12 p-0">
        <button (click)="close()" class="btn btn-secondary float-left" type="button">
          <i aria-hidden="true" class="fas fa-times"></i>
          {{ 'General.close' | translate }}
        </button>
        <button *ngIf="!isDeciphering()" (click)="decipher()" class="btn btn-warning float-right" type="button">
          <i class="fa fa-unlock" aria-hidden="true"></i>
          {{ 'TenderEvent.decipherAction' | translate }}
        </button>
      </div>
    </div> -->
  </div>
</p-scrollPanel>